// src/components/RouteTransition.jsx
//
// Triggers the existing <PageTransition> overlay whenever the
// browser URL changes — works for both real navigation (back/
// forward) and the in-app navigateTo() helper which dispatches
// a synthetic popstate after pushState.
//
// Mounted once around <BrandRouter /> at the App root so every
// public-page nav (BrandHome ↔ Contact ↔ Legal ↔ Trading
// Resources etc.) sweeps cleanly instead of a hard cut.
//
import React, { useEffect, useState } from 'react';
import PageTransition from './PageTransition';

export default function RouteTransition({ children }) {
  const [path, setPath] = useState(() =>
    typeof window === 'undefined' ? '/' : window.location.pathname
  );

  useEffect(() => {
    const onChange = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onChange);
    return () => window.removeEventListener('popstate', onChange);
  }, []);

  // Skip the transition overlay on touch devices. The backdrop-filter:
  // blur animation in PageTransition is a big mobile perf cost and the
  // overlay can briefly intercept compositing work during fast nav.
  // Native instant page swap feels better on phones.
  const isTouch =
    typeof window !== 'undefined' &&
    (
      ('ontouchstart' in window) ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      (window.matchMedia &&
        (window.matchMedia('(pointer: coarse)').matches ||
          window.matchMedia('(hover: none)').matches))
    );
  if (isTouch) return <>{children}</>;

  return <PageTransition viewKey={path}>{children}</PageTransition>;
}
